// extracted by mini-css-extract-plugin
export default {"blockwrapper":"gR","header":"hR","name":"iR","columns":"jR","imagewrapper":"kR","addinfo":"lR","description":"mR","price":"nR","old":"oR","new":"pR","desc_d":"qR","infoblock":"rR","desc_m":"sR"};
    if(module.hot) {
      // 1714654894595
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  